import { useState, useRef } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import linkicon from "../../../assets/images/home_page_images/link.svg";
import classes from "../../../assets/styles/PageComponentsStyles/Home/ShowCustomURLS.module.css";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import html2canvas from "html2canvas";
import CustomURLSAddEditModal from "../../Modals/CustomURLSAddEditModal";
import { useAtom } from "jotai";
import { mobileViewCheck } from "../../../utils/store";
import ShareModal from "../../Modals/ShareModal";
import QRCodeModal from "../../Modals/QRCodeModal";

const ShowCustomURLS = ({
  id,
  title,
  url_path,
  uuid,
  emptyCustomUrlData,
  handleSaveShowModal,
  selectedData,
  setSelectedData,
  handleCustomDelete,
  loading,
  publicMode,
}) => {
  const target = useRef(null);

  const [showCopyPopup, setShowCopyPopup] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mobileView] = useAtom(mobileViewCheck);

  const handleOpenModal = () => {
    let newObj = {
      id,
      title,
      url_path,
    };

    setSelectedData(newObj);

    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedData(emptyCustomUrlData);
    setShowModal(false);
  };

  const handleQrOpen = () => {
    setQrOpen(true);
  };

  const handleQRClose = () => {
    setQrOpen(false);
    setShowCopyPopup(false);
  };

  const handleShareOpen = () => {
    setShareOpen(true);
  };

  const handleShareClose = () => {
    setShareOpen(false);
    setShowCopyPopup(false);
  };

  const handleDownload = () => {
    html2canvas(document.querySelector("#qr-code")).then(function (canvas) {
      const link = document.createElement("a");
      link.download = "qrcode.png";
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  return (
    <>
      <div className={classes.linkWrapper}>
        <div className={classes.contentWrapper}>
          <div className={classes.imgWrapper}>
            <img src={linkicon} alt="" />
          </div>
          <div>
            <p className={classes.title}>{title}</p>
            <a
              href={url_path}
              className={classes.urlPath}
              target="_blank"
              style={{ display: "block" }}
              rel="noreferrer"
            >
              {url_path}
            </a>
          </div>
        </div>
        <div className={classes.actionsWrapper}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={classes.threeDotsIcon} />
          </button>
          {publicMode ? (
            <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
              <li>
                <a
                  href={url_path}
                  target="_blank"
                  className="dropdown-item"
                  rel="noreferrer"
                >
                  Visit Link
                </a>
              </li>
              <li>
                <span className="dropdown-item" onClick={handleQrOpen}>
                  QR Code
                </span>
              </li>
            </ul>
          ) : (
            <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
              <li>
                <span className="dropdown-item" onClick={handleQrOpen}>
                  QR Code
                </span>
              </li>
              <li>
                <span className="dropdown-item" onClick={handleOpenModal}>
                  Edit
                </span>
              </li>
              <li>
                <span className="dropdown-item" onClick={handleShareOpen}>
                  Share
                </span>
              </li>
              <li>
                <span
                  className="dropdown-item"
                  // style={{ color: "var(--error_color)" }}
                  onClick={() => handleCustomDelete(id)}
                >
                  Delete
                </span>
              </li>
            </ul>
          )}
        </div>
      </div>

      {showModal && (
        <CustomURLSAddEditModal
          show={showModal}
          data={selectedData}
          setSelectedData={setSelectedData}
          handleSaveShowModal={async () => {
            await handleSaveShowModal(selectedData);
            handleCloseModal();
          }}
          handleCloseModal={handleCloseModal}
          loading={loading}
        />
      )}
      {qrOpen && (
        <QRCodeModal
          qrOpen={qrOpen}
          target={target}
          handleQRClose={handleQRClose}
          setShowCopyPopup={setShowCopyPopup}
          handleDownload={handleDownload}
          functionType="customUrl"
          functionUuid={uuid}
        />
      )}

      {shareOpen && (
        <ShareModal
          target={target}
          shareOpen={shareOpen}
          handleShareClose={handleShareClose}
          setShowCopyPopup={setShowCopyPopup}
          functionType="customUrl"
          functionUuid={uuid}
        />
      )}

      <Overlay
        target={target.current}
        show={showCopyPopup}
        placement={mobileView ? "left" : "right"}
      >
        {(props) => (
          <Tooltip id="overlay-example" {...props}>
            Link Copied
          </Tooltip>
        )}
      </Overlay>
    </>
  );
};

export default ShowCustomURLS;
